import React, { useMemo, useState } from "react"
import { useQuery } from "react-query"
import { getRejectedLoans } from "services/LoanService"
import { REJCOLUMNS } from "./rejColumns"
import { Table } from "antd"
import FilterComp from "../FilterComp"
import { usePaginate } from "hooks/usePagination"


const RejLoansComp = () => {

	const {page,setPage,limit,setLimit} = usePaginate()

	const [searchQuery, updateSearchQuery] = useState("")

	const { data: res, isLoading } = useQuery(
		["rejected-loans",page,limit,searchQuery],
		()=>getRejectedLoans({page,limit,search:searchQuery}))

	const filterDataByName = (rejLoans) => rejLoans;

	const setSearchQuery = (queryString)=>{
		updateSearchQuery(queryString)
		setPage(1)
		setLimit(10)
	}


	const columns = useMemo(() => REJCOLUMNS, [])
	const data = useMemo(() => {
		const rejLoanna = res?.data?.loans ? res?.data?.loans : []
		return rejLoanna
	}, [res])

	const pagination = useMemo(()=>{
		console.log(res?.data?.pagination)
				return {
					nextPageUrl:null,
					offset:0,
					limit:10,
					total:res?.data?.total ?? 10,
					page:1,
					prevPage:null,
					prevPageUrl:null,
					nextPage:null,
					totalPages:1,
					...res?.data?.pagination
				}
			},[res])
	
		const tablePagination ={
			total:pagination.total,
			current:pagination.page,
			onShowSizeChange:(_,size)=>{
				setLimit(size)
			},
			onChange:(pageNumber)=>{
				setPage(pageNumber)
			},
			pageSize:limit,
			nextIcon:()=>{
				const next = ()=> pagination.nextPage? setPage(pagination.nextPage) :undefined
				if(!pagination.nextPage) return null;
				return (
					<button onClick={next}> <i className="bi bi-chevron-right"></i></button>
				)
			},
			prevIcon:()=>{
				const prev = ()=> pagination.prevPage? setPage(pagination.prevPage) :undefined
				if(!pagination.prevPage) return null;
				return (
					<button onClick={prev}> <i className="bi bi-chevron-left"></i></button>
				)
			}
		}

	return (
		<>
			<div>
				<FilterComp filter={searchQuery} setFilter={setSearchQuery} />
				<Table
					scroll={{ x: 'max-content' }}
					columns={columns}
					pagination={tablePagination}
					loading={isLoading}
					dataSource={filterDataByName(data)}/>
			</div>
		</>
	)
}

export default RejLoansComp
